/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Cog = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M15.9 11.1l1.3.7c.1.1.2.3.2.4-.3 1.1-.9 2-1.6 2.8-.1.1-.3.2-.4.1l-1.3-.7c-.5.5-1.2.8-1.8 1.1V17c0 .2-.1.3-.3.4-1.1.2-2.2.2-3.3 0-.2 0-.3-.2-.3-.4v-1.5c-.7-.2-1.3-.6-1.8-1.1l-1.3.7c-.1.1-.3.1-.4-.1-.7-.8-1.3-1.8-1.6-2.8-.1-.2 0-.3.2-.4l1.3-.7c-.1-.7-.1-1.4 0-2.1l-1.6-.8c-.1-.1-.2-.3-.2-.4.3-1.1.9-2 1.6-2.8.2-.2.4-.2.5-.1l1.3.7c.6-.5 1.2-.8 1.8-1.1V3.1c0-.2.1-.3.3-.4 1.1-.2 2.2-.2 3.3 0 .2 0 .3.2.3.4v1.5c.7.2 1.3.6 1.8 1.1l1.3-.7c.1-.1.3-.1.4.1.7.8 1.3 1.8 1.6 2.8.1.2 0 .3-.2.4l-1.3.7c.3.6.3 1.4.2 2.1zM12.6 10c0-1.3-1.1-2.4-2.4-2.4S7.8 8.7 7.8 10s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4z" />
  </svg>
);

export default extendIcon(Cog);
